/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Duplicate_RowInputs */

const en_issue_duplicate_row = /** @type {(inputs: Issue_Duplicate_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is in the file more than once`)
};

/**
* | output |
* | --- |
* | "is in the file more than once" |
*
* @param {Issue_Duplicate_RowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_duplicate_row = /** @type {((inputs?: Issue_Duplicate_RowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Duplicate_RowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_duplicate_row(inputs)
});